import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Form } from "react-router-dom";

//CSS
import styles from "./slideShow.module.less";

export default function SlideShow ({slides}) {
  const [t,i18n] = useTranslation("home","global");
  const [actualImg, setActualImg] = useState(0);

  //console.log(slides);
  
  function handleChangeImg(direcction){
    if (direcction === "right"){
      if (actualImg < slides.length-1) setActualImg(actualImg+1);
      else setActualImg(0);
    }else if (direcction === "left"){
      if (actualImg > 0) setActualImg(actualImg-1);
      else setActualImg(slides.length-1);
    }
  }

  useEffect(()=>{
    const interval = setInterval(() => {
      handleChangeImg('right');
    }, 5000);
    return () => clearInterval(interval);
  },[actualImg])

  let slidesHTML = null;

  if(Array.isArray(slides) && slides.length > 0){
    slidesHTML = slides.map((slide,index)=>{
      const imgid="img-"+index;
      const show = actualImg === index ? styles.slideImg + ' ' + styles.fadeIn :  styles.slideImg + ' ' + styles.fadeOut;
      return (
        <div key={index} className={show} id={imgid}>
          <img key={index} src={slide.img} />
        </div>
      );
    });
  }

  return (
    <div className={styles.slideshow}>

      <div className={styles.slideImgsContent}>{slidesHTML}</div>

      <Form method="post" action={'/' + i18n.language + '/search'}>
        <div className={styles.finderContent}>
          <div className={styles.finderBG}>&nbsp;</div>
          <div className={styles.finder}>
              <div className={styles.formelement}>
                <select name="zone">
                  <option value="" disabled>{t('Donde se encuentra')}</option>
                  <option value="south">{t('Zona sur')}</option>
                  <option value="north">{t('Zona Puerto de la Cruz')}</option>
                </select>
              </div>

              <div className={styles.formelement}>
                <input type="text" name="findtext" placeholder={t('Que desea hacer')} />
              </div>

              <div className={styles.formelement}>
                <input type="submit" value={t('Buscar')} />
              </div>
          </div>
        </div>
      </Form>
    </div>
  );

}